import { createSlice } from '@reduxjs/toolkit';
import { UserFinancialMetrics } from 'api/FinancialMetricsApi';
import { getFinancialMetrics } from 'thunks';

export interface FinancialMetricsState {
  data: UserFinancialMetrics | null;
  isLoading: boolean;
  isError: boolean;
}

const initialState: FinancialMetricsState = {
  data: null,
  isLoading: false,
  isError: false,
};

const financialMetrics = createSlice({
  name: 'financialMetrics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFinancialMetrics.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });

    builder.addCase(getFinancialMetrics.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
    });

    builder.addCase(getFinancialMetrics.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export default financialMetrics.reducer;
